@if (diffPartnerNamespace$ | async) {
  <glxy-page-no-access-unauthorized />
} @else {
  @if (canShowSidebyPreview) {
    <div class="row row-gutters">
      <div class="settings-col col col-xs-12 col-md-6">
        <ng-container *ngTemplateOutlet="mainform"></ng-container>
      </div>

      <div class="preview-col col col-xs-12 col-md-6">
        <div class="preview-box">
          <div
            class="webchat-preview-container webchat-preview-container--in-col"
            [class.webchat-preview-container--left]="webChatForm().get('position')?.value === left"
            [class.webchat-preview-container--right]="webChatForm().get('position')?.value !== left"
            [class.webchat-preview-container--in-col--left]="webChatForm().get('position')?.value === left"
            [class.webchat-preview-container--in-col--right]="webChatForm().get('position')?.value !== left"
          >
            <ng-container *ngTemplateOutlet="webchatpreview"></ng-container>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="mainform"></ng-container>
  }
}

<ng-template #mainform>
  <div class="config-cards-group">
    <form [formGroup]="webChatForm()">
      <div class="config-cards-group">
        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <glxy-form-field>
              <input
                matInput
                id="name"
                formControlName="name"
                [placeholder]="'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME' | translate"
              />
              <glxy-hint>
                {{ 'INBOX.WEBCHAT.SETTINGS.WIDGET_NAME_DESCRIPTION' | translate }}
              </glxy-hint>
            </glxy-form-field>
          </mat-card-content>
        </mat-card>

        @if (!!associatedAssistant()) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_ASSISTANT_TITLE' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <glxy-hint>
                {{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_ASSISTANT.DESCRIPTION' | translate }}
              </glxy-hint>
              <ai-assistant-reference-card [assistant]="associatedAssistant()"></ai-assistant-reference-card>
            </mat-card-content>
          </mat-card>
        }

        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_WELCOME_MESSAGE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p [innerHTML]="'INBOX.WEBCHAT.SETTINGS.WEBCHAT_WELCOME_MESSAGE_DESCRIPTION' | translate"></p>
            <glxy-form-field>
              <textarea
                matInput
                id="welcome-message"
                formControlName="welcomeMessage"
                [placeholder]="'INBOX.WEBCHAT.SETTINGS.WEBCHAT_WELCOME_MESSAGE_PLACEHOLDER' | translate"
                #welcomeMessageLimit
              ></textarea>
              @if (welcomeMessageLimit.value?.length <= welcomeMessageCharLimit) {
                <glxy-hint align="right"
                  >{{ welcomeMessageLimit.value?.length || 0 }} / {{ welcomeMessageCharLimit }}
                </glxy-hint>
              } @else {
                <glxy-error align="end">
                  {{ welcomeMessageLimit.value?.length || 0 }} / {{ welcomeMessageCharLimit }}
                </glxy-error>
              }
            </glxy-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title class="enable-greeting-message">
              <mat-checkbox formControlName="enableGreetingMessage"></mat-checkbox>
              {{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_CUSTOM_GREETING' | translate }}
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p [innerHTML]="'INBOX.WEBCHAT.SETTINGS.WEBCHAT_CUSTOM_GREETING_DESCRIPTION' | translate"></p>

            <glxy-form-field>
              <textarea
                matInput
                id="custom-greeting-message"
                formControlName="customGreetingMessage"
                [placeholder]="'INBOX.WEBCHAT.SETTINGS.WEBCHAT_CUSTOM_GREETING_PLACEHOLDER' | translate"
                #customGreetingMessageLimit
              ></textarea>
              @if (customGreetingMessageLimit.value?.length <= customGreetingMessageCharLimit) {
                <glxy-hint align="right"
                  >{{ customGreetingMessageLimit.value?.length || 0 }} / {{ customGreetingMessageCharLimit }}
                </glxy-hint>
              } @else {
                <glxy-error align="end">
                  {{ customGreetingMessageLimit.value?.length || 0 }} / {{ customGreetingMessageCharLimit }}
                </glxy-error>
              }
            </glxy-form-field>
          </mat-card-content>
        </mat-card>

        <mat-card>
          <mat-card-header>
            <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.APPEARANCE' | translate }}</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="color-picker-container">
              <glxy-form-field>
                <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.PRIMARY_COLOR' | translate }}</glxy-label>
                <input
                  matInput
                  type="color"
                  id="color-picker"
                  formControlName="color"
                  [value]="webChatForm().value['color']"
                  (change)="setTextColor()"
                />
                <input
                  matInput
                  id="color"
                  formControlName="color"
                  placeholder="#555555"
                  [value]="webChatForm().value['color']"
                  (change)="setTextColor()"
                />
                <glxy-error *ngIf="webChatForm().get('color').invalid">
                  {{ 'INBOX.WEBCHAT.SETTINGS.INVALID_COLOR' | translate }}
                </glxy-error>
              </glxy-form-field>
            </div>
            <glxy-form-field>
              <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.TEXT_COLOR' | translate }}</glxy-label>
              <mat-button-toggle-group [formControl]="webChatForm().controls?.textColor" activeColor="primary">
                <mat-button-toggle value="dark">
                  {{ 'INBOX.WEBCHAT.SETTINGS.DARK' | translate }}
                </mat-button-toggle>
                <mat-button-toggle value="light">
                  {{ 'INBOX.WEBCHAT.SETTINGS.LIGHT' | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </glxy-form-field>

            <div class="color-picker-container">
              <glxy-form-field>
                <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.ACCENT_COLOR' | translate }}</glxy-label>
                <input
                  matInput
                  type="color"
                  id="accent-color-picker"
                  formControlName="accentColor"
                  [value]="webChatForm().value['accentColor']"
                  (change)="setAccentTextColor()"
                />
                <input
                  matInput
                  id="accentColor"
                  formControlName="accentColor"
                  placeholder="#555555"
                  [value]="webChatForm().value['accentColor']"
                  (change)="setAccentTextColor()"
                />
                <glxy-error *ngIf="webChatForm().get('accentColor').invalid">
                  {{ 'INBOX.WEBCHAT.SETTINGS.INVALID_COLOR' | translate }}
                </glxy-error>
              </glxy-form-field>
            </div>
            <glxy-form-field>
              <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.ACCENT_TEXT_COLOR' | translate }}</glxy-label>
              <mat-button-toggle-group [formControl]="webChatForm().controls?.accentTextColor" activeColor="primary">
                <mat-button-toggle value="dark">
                  {{ 'INBOX.WEBCHAT.SETTINGS.DARK' | translate }}
                </mat-button-toggle>
                <mat-button-toggle value="light">
                  {{ 'INBOX.WEBCHAT.SETTINGS.LIGHT' | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </glxy-form-field>

            <glxy-form-field>
              <glxy-label>{{ 'INBOX.WEBCHAT.SETTINGS.POSITION' | translate }}</glxy-label>
              <mat-button-toggle-group [formControl]="webChatForm().controls?.position" activeColor="primary">
                <mat-button-toggle [value]="WebChatPosition.WIDGET_POSITION_LEFT">
                  {{ 'INBOX.WEBCHAT.SETTINGS.LEFT' | translate }}
                </mat-button-toggle>
                <mat-button-toggle [value]="WebChatPosition.WIDGET_POSITION_RIGHT">
                  {{ 'INBOX.WEBCHAT.SETTINGS.RIGHT' | translate }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </glxy-form-field>

            <glxy-form-field>
              <glxy-label>
                {{ 'INBOX.WEBCHAT.SETTINGS.MOBILE_CTA_TITLE' | translate }}
              </glxy-label>
              <mat-checkbox formControlName="showMobileCta">
                {{ 'INBOX.WEBCHAT.SETTINGS.MOBILE_CTA_DESCRIPTION' | translate }}
              </mat-checkbox>
            </glxy-form-field>
          </mat-card-content>
        </mat-card>

        @if (canShowPreview()) {
          <mat-card [class.preview-small-screen-card]="canShowSidebyPreview">
            <mat-card-header>
              <mat-card-title>{{ 'INBOX.WEBCHAT.SETTINGS.WEBCHAT_PREVIEW' | translate }}</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div
                class="webchat-preview-container"
                [class.webchat-preview-container--left]="webChatForm().get('position')?.value === left"
                [class.webchat-preview-container--right]="webChatForm().get('position')?.value !== left"
              >
                <ng-container *ngTemplateOutlet="webchatpreview"></ng-container>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </form>
    <ng-content></ng-content>
  </div>

  <inbox-sticky-footer
    [submitOverride]="submitCTA()"
    (submitClick)="submit()"
    [disabled]="isLoading()"
  ></inbox-sticky-footer>
</ng-template>

<ng-template #webchatpreview>
  <webchat-box
    class="webchat-box"
    (clickedClose)="toggleChat()"
    [class.hidden]="!showWebchat()"
    [messages]="[]"
    [messageGroups]="greetingMessageGroup()"
    [currentParticipantId]="tempParticipantId"
    [webchatColor]="webChatForm().get('color')?.value"
    [webchatTextColor]="webChatForm().get('textColor')?.value"
    [webchatAccentColor]="webChatForm().get('accentColor')?.value"
    [webchatAccentTextColor]="webChatForm().get('accentTextColor')?.value"
    [welcomeMessage]="webChatForm().get('welcomeMessage')?.value"
    [assistantName]="associatedAssistant()?.name"
    [assistantAvatarUrl]="associatedAssistant()?.avatarUrl"
    [position]="webChatForm().get('position')?.value"
    [absolutePosition]="false"
    [placeholder]="'INBOX.WEBCHAT.WIDGET.SENDING_DISABLED_FOR_PREVIEW' | translate"
    [showFooterContent]="showFooterContent$ | async"
    [poweredBy]="poweredBy$ | async"
  ></webchat-box>
  <div class="webchat-button-container">
    <webchat-button-preview
      (clicked)="toggleChat()"
      [hideStatus]="showWebchat()"
      [backgroundColor]="webChatForm().get('color')?.value"
      [iconColor]="webChatForm().get('textColor')?.value"
      [position]="webChatForm().get('position')?.value === left ? 'left' : 'right'"
    ></webchat-button-preview>
  </div>
</ng-template>
